<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
  padding-bottom: 40px;
}

.billSelect {
  .el-select-dropdown__item {
    height: 68px;
  }
}
</style>
<template>
  <div class="coustomer-wrap">
    <el-dialog
      title="客户退款"
      :visible.sync="dialogVisible"
      v-loading="pageLoading"
      top="3vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="460px">
      <el-form
        ref="formDataRef"
        :model="formData"
        label-width="90px"
        label-position="left"
        class="clearfix"
        size="medium">
        <el-form-item prop="title" label="用款事由">
          <el-input v-model="formData.title" placeholder="请填写用款事由"></el-input>
        </el-form-item>

        <el-form-item prop="owner_company_id" label="我方公司">
          <el-select
            v-model="formData.owner_company_id"
            filterable
            placeholder="请选择公司主体"
            @change="ownerCompanyChange"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="companyItem in companys"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id">{{ companyItem.name }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="other_company_id" label="对方公司">
          <template slot="label">
            对方公司
            <az-issue :tipW="260" text="列表中如果没有所需公司，请在 企业管理 中添加客户，如没有添加权限，请联系财务人员添加。">
            </az-issue>
          </template>
          <el-select
            v-model="formData.other_company_id"
            filterable
            placeholder="选择相关企业"
            :collapse-tags="true"
            @change="chooseOtherCompanyHandler"
            style="width: 100%;">
            <el-option
              v-for="companyItem in otherCompanys"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id">{{ companyItem.name }}</el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="other_bank_id	" label="对方公司银行">
          <el-select
            v-model="formData.other_bank_id"
            placeholder="选择对方公司银行"
            popper-class="ag-select-popper"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="bankItem in otherCompanyBanks"
              :label="bankItem.number"
              :key="bankItem.id"
              :value="bankItem.id">
              <div style="padding: 5px 0;">
                <span>卡号：{{ bankItem.number }}</span>
                <div
                  style="line-height: 18px; color: #aaa;">
                  开户行：{{ `${bankItem.name} ${bankItem.address}` }}</div>
                <div
                  style="line-height: 18px; color: #aaa; padding: 10px 0;">
                  备注：{{ bankItem.remark || '无' }}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="last_pay_time	" label="最晚付款时间">
          <el-date-picker
            style="width: 100%;"
            v-model="formData.last_pay_time"
            format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="date"
            placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item prop="coin_type	" label="选择币种">
          <el-select
            v-model="formData.coin_type"
            placeholder="请选择币种"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="coinItem in coins"
              :label="coinItem.name"
              :key="coinItem.id"
              :value="coinItem.id">{{ coinItem.name }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sum_money	" label="用款金额">
          <el-input-number
            style="width: 100%;"
            v-model="formData.sum_money"
            :precision="2"
            :step="1"
            :min="0"
            :max="999999999"
            @blur="moneyChangeHandler(formData.sum_money, formData)"></el-input-number>
        </el-form-item>
        <el-form-item prop="remark	" label="备注信息">
          <el-input v-model="formData.remark" type="textarea" placeholder="请填写备注信息">
          </el-input>
        </el-form-item>
        <el-form-item label="上传附件" class="extension">
          <template slot="label">
            上传附件
            <az-issue :tipW="200" text="仅支持jpg , jpeg, png, pdf"></az-issue>
          </template>
          <div class="invoice-wrap1">
            <el-upload
              ref="upload"
              drag
              class="avatar-uploader"
              :file-list="formData.img_keys"
              :action="`/api/base/upload?az_tk=${token}`"
              :on-remove="handleRemove"
              accept=".jpg, .jpeg, .png, .pdf"
              :on-exceed="handleExceed"
              :limit="5"
              :on-success="(res, file, fileList) => handleAvatarSuccess(res, file, fileList)"
              :before-upload="(file) => beforeAvatarUpload(file)">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button
          slot="reference"
          size="small"
          type="primary"
          :loading="btnIsLoading"
          @click="submitHandler">确认提交</el-button>
        <el-button
          slot="reference"
          size="small"
          @click="dialogVisible = false"
          style="margin-left: 10px;">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { coins } from '@/const'
import { getCompanyList, getCompanyDetail } from '@/api/company'
import azIssue from '@/base/azIssue.vue'
import { createApprovalInstance, modifyOriginalFrom } from '@/api/approval'

const formDataDefault = {
  title: '', // 事由
  owner_company_id: '', // 我方公司主体ID
  sum_money: 0, // 总金额
  other_company_id: '', // 对方公司ID
  other_bank_id: '',// 对方银行ID
  last_pay_time: '', // 最晚付款日期
  coin_type: '', // 币种: 1人民币, 2美元,3新币,4日元,5韩元
  remark: '',
  img_keys: [], // 附件

}
export default {
  name: 'clientRefund', // 用款申请
  props: {

  },
  components: {
    azIssue
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
  data() {
    return {
      pageLoading: false,
      coins,
      basic_type: '',
      operationType: 'create',
      task_id: '',
      formData: JSON.parse(JSON.stringify(formDataDefault)),
      dialogVisible: false,
      btnIsLoading: false,
      type: 'create',
      companys: [],
      otherCompanys: [],
      otherCompanyBanks: [],
    }
  },

  mounted() {
    this.$on('open', (basic_type) => {
      this.basic_type = basic_type;
      this.operationType = 'create';
      this.formData = JSON.parse(JSON.stringify(formDataDefault))
      this.initPage()
      this.dialogVisible = true
    })
    this.$on('edit', (task_id, data) => {
      console.log(data, 'data')
      this.operationType = 'edit';
      this.task_id = task_id;
      this.dialogVisible = true;
      const {
        title, // 事由
        owner_company_id, // 我方公司主体ID
        sum_money, // 总金额
        other_company_id, // 对方公司ID
        other_bank_id,// 对方银行ID
        last_pay_time, // 最晚付款日期
        coin_type, // 币种: 1人民币, 2美元,3新币,4日元,5韩元
        remark,
        img_keys, // 附件
      } = data;

      this.formData = {
        title, // 事由
        owner_company_id, // 我方公司主体ID
        sum_money, // 总金额
        other_company_id, // 对方公司ID
        other_bank_id,// 对方银行ID
        last_pay_time, // 最晚付款日期
        coin_type, // 币种: 1人民币, 2美元,3新币,4日元,5韩元
        remark,
        img_keys: img_keys || [],
      }
      this.initPage();

    })
  },
  methods: {


    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.formData.img_keys = fileList;
    },
    handleExceed(files, fileList) {
      this.$message({
        message: '同时最多只能上传5个文件',
        type: 'error'
      });
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
      } else {
        this.formData.img_keys.push({ name: file.name, key: res.data.key });
        this.$message({
          message: '上传成功',
          type: 'success'
        });
      }
    },
    beforeAvatarUpload(file) {
      console.log(file)
      console.log(this.fileList, 'fileList')
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      return true
    },
    moneyChangeHandler(moeny, item) {
      if (typeof moeny !== 'number') {
        item.money = 0
      }
    },
    ownerCompanyChange(owner_company_id) {
      this.otherCompanys = []
      this.formData.other_company_id = ''
      this.otherCompanyBanks = [];
      this.formData.other_bank_id = ''
      getCompanyList({ status: 2, page: 1, per_page: 10000, type: 3, owner_company: owner_company_id }).then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.otherCompanys = res.data.items
      }).catch(err => {
        console.log(err.message)
      })
    },
    chooseOtherCompanyHandler(company_id) {
      this.otherCompanyBanks = []
      this.formData.other_bank_id = ''
      getCompanyDetail(company_id).then(res => {
        if (res.code != 0) throw new Error(res.message)
        const banks = res.data.bank_infos
        this.otherCompanyBanks = banks
      }).catch(err => {
        console.log(err.message)
      })

    },
    async initPage() {
      // 创建和编辑初始化共用的
      this.pageLoading = true;
      // 我放公司
      let companyRes = await getCompanyList({ status: 2, page: 1, per_page: 1000, type: 1 });
      if (companyRes.code === 0 && companyRes.data && Array.isArray(companyRes.data.items)) this.companys = companyRes.data.items;

      if (this.operationType == 'edit') { // 编辑额外需要初始化的

        // 根据我方公司id获取对方公司列表
        let otherCompanyRes = await getCompanyList({ status: 2, page: 1, per_page: 1000, type: 3, owner_company: this.formData.owner_company_id });
        if (otherCompanyRes.code === 0 && otherCompanyRes.data && Array.isArray(otherCompanyRes.data.items)) this.otherCompanys = otherCompanyRes.data.items;
        // 根据对方公司id获取对方银行信息
        let companyDetailRes = await getCompanyDetail(this.formData.other_company_id)
        if (companyDetailRes.code === 0 && companyDetailRes.data) this.otherCompanyBanks = companyDetailRes.data.bank_infos
      }
      this.pageLoading = false

    },
    createApprovalInstanceHandler() {
      this.btnIsLoading = true
      createApprovalInstance(this.basic_type, this.formData).then(res => {
        console.log('res', res)
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.btnIsLoading = false
      })
    },
    editApprovalInstanceHandler() {
      this.btnIsLoading = true
      modifyOriginalFrom(this.task_id, this.formData).then(res => {
        console.log('res', res)
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.btnIsLoading = false
      })
    },
    submitHandler() {
      this.formData.img_keys = this.formData.img_keys.map(item => {
        return { name: item.name, key: item.key }
      })
      this[`${this.operationType}ApprovalInstanceHandler`]()
    },
  },

}
</script>